import { Observable } from "rxjs";

import st from "lib/utils/index";
import { CompanyRepository } from "lib/repositories/index";
import { createFormInstance } from "modules/utils/index";
import { fetchCurrentCompany } from "modules/auth";

export const INITIALIZE_VIEW = "settings/CompanySettingsView/INITIALIZE_VIEW";
export const INITIALIZE_MODEL = "settings/CompanySettingsView/INITIALIZE_MODEL";
export const UPDATE_MODEL = "settings/CompanySettingsView/UPDATE_MODEL";
export const VALIDATE = "settings/CompanySettingsView/VALIDATE";
export const SUBMIT = "settings/CompanySettingsView/SUBMIT";
export const FETCH_SUBMIT_START = "settings/CompanySettingsView/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "settings/CompanySettingsView/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "settings/CompanySettingsView/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.settings.CompanySettingsView;

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  validate: ({ form: { model } }, errors) => {
    errors.add(`model.name`, st.validators.presence(model.name));
  },
  submitModel: ({ form: { initialModel, model } }) => {
    return CompanyRepository.update(
      {
        id: model.id,
        name: model.name,
        logo_image: model.logo_image,
        contact_email: model.contact_email,
        contact_phone_number: model.contact_phone_number,
        contact_full_address: model.contact_full_address,
        contact_website_url: model.contact_website_url,
        contact_facebook_url: model.contact_facebook_url,
        contact_opening_hours: model.contact_opening_hours,
        contact_languages: model.contact_languages,
        notifications_email: model.notifications_email,
        notifications_phone_number: model.notifications_phone_number,
        locale: model.locale,
        company_locale: model.locale,
        time_zone_name: model.time_zone_name,
        location_name: model.location_name,
        location_lat: model.location_lat,
        location_lng: model.location_lng,
      },
      null,
      { useFormData: true }
    );
  },
});

const initialState = {
  form: formInstance.initialState,
};

const reducers = {
  ...formInstance.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,
};

const epics = [
  ...formInstance.epics,

  (actions$, { getState }) =>
    actions$.ofType(INITIALIZE_VIEW).map(() => {
      const company = getState().auth.company.model;
      return initializeModel(company);
    }),

  (actions$) => actions$.ofType(FETCH_SUBMIT_SUCCESS).mapTo(fetchCurrentCompany()),
];

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export const { initializeModel, updateModel, validate, submit } = formInstance.actions;

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/settings/CompanySettingsView/index.js